import React, { useState, useMemo, useContext } from "react";
import CardContainer from "./CardContainer";
import { InputContext } from "../../../shared/contexts/InputContext";
import { formatDateLongString } from "../../../shared/utils/dateUtils";
import classes from "./ChoiceContainer.module.css";

const ChoiceContainer = ({ data, onCardClick }) => {
  const { inputs } = useContext(InputContext)
  const [hoveredBenefitType, setHoveredBenefitType] = useState(null);

  const { dateDisplay, filterDate } = useMemo(() => {
    let filterDate = null;

    if (data.retirementType === "partial") {
      filterDate = inputs.memberInfo.dateOfPartRet
    } else if (data.retirementType === "full") {
      filterDate = inputs.memberInfo.dateOfFullRet;
    }

    const dateDisplay = formatDateLongString(filterDate);

    return { dateDisplay, filterDate };
  }, [data.retirementType, inputs.memberInfo.dateOfPartRet, inputs.memberInfo.dateOfFullRet]);

  return (
    <div className={classes.choice_container}>
      <h2>
        {data.title} {dateDisplay}
      </h2>
      <p>{data.description}</p>
      <div className={classes.group_wrapper}>
        {data.schemes.map((scheme, index) => (
          <CardContainer
            key={index}
            scheme={scheme}
            retirementType={data.retirementType}
            hoveredBenefitType={hoveredBenefitType}
            onMouseEnter={setHoveredBenefitType}
            onMouseLeave={() => setHoveredBenefitType(null)}
            onCardClick={onCardClick}
            filterDate={filterDate}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(ChoiceContainer);
